/**
 * !!! VERY IMPORTANT !!!
 * there is a copy of this file at  /server/utils/deep-encode-strings.js used when
 * sending orders to TextBroker; both files should be kept in sync
 * 
 * Recursively encodes all string values in an object or array using a provided encoder function.
 * Leaves other types (numbers, arrays, booleans, nulls) untouched.
 *
 * @param {any} value - The input to recursively encode.
 * @param {(str: string) => string} encoder - A function that encodes a string.
 * @returns {any} A deeply encoded version of the input.
 */
export const deepEncodeStrings = (value, encoder) => {
  if (typeof value === 'string') {
    return encoder(value);
  }

  if (Array.isArray(value)) {
    return value.map(item => deepEncodeStrings(item, encoder));
  }

  if (value !== null && typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value).map(([key, val]) => [
        key,
        deepEncodeStrings(val, encoder),
      ])
    );
  }

  return value;
};
